import React, { useMemo } from 'react'

import ScoreDividingLine from '@components/ScoreBoard/ScoreDividingLine'
import EachScoreBox from '@components/ScoreBoard/EachScoreBox'

type ScoreBoardProps = {
  countWrittenScore: number
  countPracticalScore: number
  isPass: boolean
  isPublic: boolean
}

const ScoreBoard: React.FC<ScoreBoardProps> = ({
  countWrittenScore,
  countPracticalScore,
  isPass,
  isPublic,
}) => {
  const failureInformText = useMemo(() => {
    const isWrittenFailed = countWrittenScore < 21
    const isPracticalFailed = countPracticalScore < 27

    if (isWrittenFailed && isPracticalFailed) {
      return '필기, 실기'
    } else if (isWrittenFailed) {
      return '필기'
    } else if (isPracticalFailed) {
      return '실기'
    } else {
      return '-'
    }
  }, [countWrittenScore, countPracticalScore])

  return (
    <>
      {!isPublic && (
        <div
          className={
            'flex mx-auto mt-8 w-full sm:w-[620px] border rounded-xl border-eaeaea text-2xl'
          }
        >
          <EachScoreBox title={'필기'} score={countWrittenScore + '/35'} />
          <ScoreDividingLine />
          <EachScoreBox title={'실기'} score={countPracticalScore + '/45'} />
          <ScoreDividingLine />
          <EachScoreBox
            title={'합격여부'}
            score={isPass ? '합격' : '불합격'}
            scoreTextColorClass={isPass ? 'text-primary-text' : 'text-errorColor'}
          />
          <ScoreDividingLine />
          <EachScoreBox title={'과락'} score={failureInformText} />
        </div>
      )}
    </>
  )
}

export default ScoreBoard
